<template>
  <div class="product-wrapper in-box flex flex-column very-small-padding" v-if="inBox">
    <div class="left-tags">
    <span class="icon-delete" v-if="inViewbox">
      <input type="checkbox" name="checkproduct" class="checkbox" :checked="checkedId" @click="$emit('checkProduct', product.variantId)"/>
      <!-- <SvgFile name="redcross" size="13" color="#B40439"/> -->
    </span>
    <span v-if="!!product.pant_length" class="pantlength-tag">
      {{ product.pant_length }}
    </span>
    </div>
    <span v-if="filterReason" class="reason-ribbon">
      {{ filterReason.reason }}
    </span>
    <span
      class="accept-heart"
      v-if="feedback && inViewbox"
    >
      <SvgFile name="heart-with-border" size="28" color="#5C7069" />
    </span>
    <svg-file :name="feedback" size="64" :color="feedback == 'close' ? 'f00' : feedback == 'star' ? 'ffc107' : '0f0'" v-else-if="feedback" />
    <div class="img-thumbnail" v-lazy-container="{ selector: 'img' }">
      <img :data-src="thumbnail" alt="" class="mb-1">
    </div>
    <div class="discount-rate" v-if="product.price.discount_percentage">
      SAVE <strong>{{ product.price.discount_percentage }}%</strong>
    </div>
    <div class="product-details flex flex-column" style="padding: 5px 10px 0 10px">
        <div v-if="product.tags && product.tags.length > 0" style="margin-bottom: 7px;">
            <span
                v-if="!!product.tags && !!product.tags.length && !!product.tags.filter(tag => tag.tag === 'Campaign' || tag === 'Campaign').length"
                class="product-tag" style="margin-right: 5px;background: #C79EB9;"
            >CAMPAIGN</span>
            <span
                v-if="!!product.tags && !!product.tags.length && !!product.tags.filter(tag => tag.tag === 'Live' || tag === 'Live').length"
                class="product-tag" style="margin-right: 5px;background: #FFE8B5;"
            >LIVE</span>
            <span
            v-if="!!product.tags && !!product.tags.length && !!product.tags.filter(tag => tag.tag === 'NOOS' || tag === 'NOOS').length"
                class="product-tag" style="margin-right: 5px;background: #AED1C3;"
            >NOOS</span>
            <span
                v-if="!!product.tags && !!product.tags.length && !!product.tags.filter(tag => tag.tag === 'Push' || tag === 'Push').length"
                class="product-tag" style="background: #ADBED2;"
            >PUSH</span>
        </div> 
      <span>
        <strong>Price: </strong>
        <span class="text-orange" :class="{ 'line-through': product.price.discount_percentage }">
          <span class="text-black">
            {{ product.price | toCurrency }}
          </span>
        </span>
      </span>
      <span v-if="product.price.discount_percentage">
        <strong>New price:</strong>
        <span class="text-orange">
          {{ product.price.sales_price | toCurrency }}
        </span>
      </span>
      <template v-if="!isOutOfStock">
        <span>
          <strong>Brand: </strong>{{ product.brand.name }}
        </span>
        <span v-if="product.variants">
          <strong>Size: </strong>{{ product.variants.size }}
        </span>
        <span>
          <strong>Materials: </strong>{{ product.material }}
        </span>
      </template>
    </div>
    <span v-if="feedbackReason" class="disliked-reason">
      {{ feedbackReason }}
    </span>
  </div>
  <div
    class="product-wrapper on-page flex flex-column very-small-padding align-center justify-content-around"
    :class="{ 'border-grey': isDisabled }"
    v-else
  >
    <span v-if="!!product.pant_length" class="pantlength-tag">
      {{ product.pant_length }}
    </span>
    <div v-if="product.tags.length > 0" class="productTags">
        <span
            v-if="!!product.tags && !!product.tags.length && !!product.tags.filter(tag => tag.tag === 'Campaign').length"
            class="product-tag" style="margin-bottom: 3px;background: #C79EB9;"
        >CAMPAIGN</span>
        <span
        v-if="!!product.tags && !!product.tags.length && !!product.tags.filter(tag => tag.tag === 'Live').length" class="product-tag" style="margin-bottom: 3px;background: #FFE8B5;"
        >LIVE</span>
        <span
            v-if="!!product.tags && !!product.tags.length && !!product.tags.filter(tag => tag.tag === 'NOOS').length"
            class="product-tag noos" style="margin-bottom: 3px;background: #AED1C3;"
        >NOOS</span>
        <span
            v-if="!!product.tags && !!product.tags.length && !!product.tags.filter(tag => tag.tag === 'Push').length"
            class="product-tag" style="background: #ADBED2;"
        >PUSH</span>
    </div>
    <span v-if="filterReason" class="reason-ribbon">
      {{ filterReason.reason }}
    </span>
    <div class="img-thumbnail" v-lazy-container="{ selector: 'img' }">
      <img :data-src="product.images.thumbnail" alt="" class="mb-1">
    </div>
    <span>
      {{ product.brand.name }}
    </span>
    <span class="text-orange" :class="{ 'line-through': product.price.discount_percentage }">
      <span class="text-black">
        <strong>{{ product.price | toCurrency }}</strong>
      </span>
    </span>
    <span class="text-orange bold" v-if="product.price.discount_percentage">
      {{ getSalesPrice(product.price) }}
    </span>
    <button
      class="btn btn-xl bg-pink very-small-margin-top"
      @click.stop="handleClick"
      :disabled="isDisabled"
      :class="{ 'style-disabled': isDisabled }"
      ref="addButton"
    >
      Style
    </button>
  </div>
</template>

<script>
export default {
  name: 'ProductInView',
  props: {
    product: {
      type: Object,
      default: () => {}
    },
    inViewbox: {
      type: Boolean,
      default: false
    },
    inBox: {
      type: Boolean,
      default: false
    },
    stylingBox: {
      type: Array,
      default: () => []
    },
    filterReason: {
      type: Object,
      default: null
    },
    feedback: {
      type: String,
      default: ''
    },
    feedbackReason: {
      type: String,
      default: ''
    },
    isOutOfStock: {
      type: Boolean,
      default: false
    },
    checked: {
      type: Boolean,
      default: false
    },
    removedList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    isDisabled () {
      return this.stylingBox.find(el => (el.id == this.product.id || this.product.variants.find(variant => variant.id == el.variantId) !== undefined)) !== undefined
    },
    thumbnail () {
      if (this.product.allImages) {
        return this.product.allImages.find(el => el.is_primary)
          ? this.product.allImages.find(el => el.is_primary).urls.original
          : (this.product.allImages.length ? this.product.allImages[0].urls.original : this.product.images.thumbnail)
      } else { return this.product.images.thumbnail }
    },
    checkedId () {
      return this.removedList.includes(this.product.id)
    }
  },
  methods: {
    handleClick () {
      this.$refs.addButton.disabled = true
      this.$emit('productClick', this.product)
    },
    getSalesPrice (price) {
      if (price.currency === 'EUR') return '€ ' + price.sales_price
      else if (price.currency === 'DKK' || price.currency === 'SEK') return price.sales_price + ' kr.'
    }
  }
}
</script>

<style lang="less" scoped>
.product-wrapper {
  width: 200px;
  height: 300px;

  border: 1px solid #bbb;
  box-sizing: border-box;
  padding: 5px;
  padding-top: 15px;
  border-radius: 10px;

  position: relative;
  overflow: hidden;
  .left-tags {
    position: absolute;
    left: 8px;
    top: 5px;
    display: flex;
    flex-direction: column;
  }
  .icon-delete {
    margin-bottom: 10px;
    cursor: pointer;

    .checkbox {
      width: 30px;
      height: 30px;
      margin: 0;
      cursor: pointer;

      @media screen and (max-width: 1920px) {
        width: 20px;
        height: 20px;
      }
    }
  }

  .pantlength-tag {
    background: #F99E98;
    font-size: 10px;
    padding: 4px 15px;
    margin-bottom: 4px;
    color: #FFF;
    font-weight: 700;
    font-family: Montserrat;
  }

  .productTags{
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 5px;
    right: 8px;
  }

  .product-tag {
    font-size: 10px;
    padding: 4px 6px;
    color: #000;
    font-weight: 700;
    font-family: Montserrat;
    align-self: flex-end;
    width: fit-content;

	&.tagsPosition {
      left: 8px;
      right: revert;
    }
  }

  .img-thumbnail {
    height: fit-content;
    width: 100%;
    text-align: center;
    min-height: 40%;
    max-height: 60%;

    img {
      height: 100%;
      max-width: 100%;
    }
  }

  .discount-rate {
    position: absolute;
    padding: 5px;
    background: #F2FF86;
    right: 0;
    top: 0;

    strong {
      font-size: 140%;
    }
  }

  .reason-ribbon {
    position: absolute;
    top: 80px;
    padding: 15px;
    width: 100%;
    text-align: center;
    color: white;
    font-weight: 700;
    background: rgba(255, 90, 90, .8);
    align-self: center;
  }

  .accept-heart {
    position: absolute;
    top: 2px;
    right: 30px;
  }

  &.on-page {
    width: 100%;
    height: 240px;

    .img-thumbnail {
      height: 60%;
    }
  }
}

.wrong-product {
  border-width: 3px !important;
  border-color: red !important;
}

/deep/.svg-icon {
  position: absolute;
}

.disliked-reason {
  font-size: 16px;
  font-weight: 700;
  margin-top: auto;
  padding: 3px;
  background: red;
  border-radius: 5px;
  text-align: center;
}

.style-disabled {
  opacity: .4;
}

.btn-xl {
  padding: 10px 30px;
}
</style>
